export default __webpack_public_path__ + "static/media/logo.a6dfbe50.svg";